module.exports = __webpack_public_path__ + "img/anjuntrack.289b7bb9.png";